var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTaxi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.52,
    x2: 235.182,
    xlinkHref: "#lg1",
    y1: 70.702,
    y2: 110.078
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.59,
    x2: 234.023,
    xlinkHref: "#lg2",
    y1: 93.536,
    y2: 121.589
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.094,
    x2: 256.54,
    xlinkHref: "#lg3",
    y1: 227.439,
    y2: 387.304
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.873,
    x2: 56.629,
    xlinkHref: "#lg4",
    y1: 215.595,
    y2: 431.979
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.531,
    x2: 146.894,
    xlinkHref: "#lg3",
    y1: 288.149,
    y2: 111.48
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.591,
    x2: 71.973,
    xlinkHref: "#lg4",
    y1: 255.321,
    y2: 181.88
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 125.801,
    x2: 125.801,
    xlinkHref: "#lg3",
    y1: 289.723,
    y2: 381.593
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.867,
    x2: 388.867,
    xlinkHref: "#lg3",
    y1: 289.723,
    y2: 381.593
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.972,
    x2: 484.802,
    xlinkHref: "#lg1",
    y1: 337.972,
    y2: 355.947
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.194,
    x2: 45.194,
    xlinkHref: "#lg2",
    y1: 368.216,
    y2: 402.383
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.806,
    x2: 464.806,
    xlinkHref: "#lg2",
    y1: 368.216,
    y2: 402.383
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.562,
    x2: 177.664,
    xlinkHref: "#lg2",
    y1: 377.115,
    y2: 445.216
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#b6b7c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6581,
    stopColor: "#a097a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8b788a"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.553,
    x2: 95.958,
    xlinkHref: "#lg5",
    y1: 414.106,
    y2: 363.511
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8b788a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.157,
    x2: 122.755,
    xlinkHref: "#lg6",
    y1: 423.714,
    y2: 390.312
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.326,
    x2: 144.201,
    xlinkHref: "#lg2",
    y1: 385.88,
    y2: 411.754
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0471,
    stopColor: "#6e566e",
    stopOpacity: 0.047
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.495,
    x2: 153.953,
    xlinkHref: "#lg7",
    y1: 401.011,
    y2: 349.942
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.629,
    x2: 440.73,
    xlinkHref: "#lg2",
    y1: 377.115,
    y2: 445.216
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.619,
    x2: 359.024,
    xlinkHref: "#lg5",
    y1: 414.106,
    y2: 363.511
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 419.223,
    x2: 385.821,
    xlinkHref: "#lg6",
    y1: 423.714,
    y2: 390.312
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.393,
    x2: 407.267,
    xlinkHref: "#lg2",
    y1: 385.88,
    y2: 411.754
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.561,
    x2: 417.02,
    xlinkHref: "#lg7",
    y1: 401.011,
    y2: 349.942
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.054,
    x2: 257.054,
    xlinkHref: "#lg2",
    y1: 368.216,
    y2: 402.383
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#65e0db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#27d2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18cefb"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.65,
    x2: 191.999,
    xlinkHref: "#lg8",
    y1: 157.043,
    y2: 232.204
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.91,
    x2: 300.641,
    xlinkHref: "#lg8",
    y1: 154.682,
    y2: 237.808
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.263,
    x2: 192.778,
    xlinkHref: "#lg2",
    y1: 266.73,
    y2: 296.749
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.694,
    x2: 228.209,
    xlinkHref: "#lg2",
    y1: 302.162,
    y2: 332.181
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.478,
    x2: 263.993,
    xlinkHref: "#lg2",
    y1: 266.73,
    y2: 296.749
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.909,
    x2: 299.424,
    xlinkHref: "#lg2",
    y1: 302.162,
    y2: 332.181
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 318.693,
    x2: 335.208,
    xlinkHref: "#lg2",
    y1: 266.73,
    y2: 296.749
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.485,
    x2: 30.865,
    y1: 317.878,
    y2: 342.016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.579,
    x2: 355.598,
    xlinkHref: "#lg4",
    y1: 263.014,
    y2: 320.02
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.08,
    x2: 359.992,
    xlinkHref: "#lg4",
    y1: 268.867,
    y2: 201.076
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.458,
    x2: 376.088,
    xlinkHref: "#lg2",
    y1: 228.498,
    y2: 245.044
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m249.438 111.189h-45.37l7.928-46.296c.704-4.111 4.267-7.116 8.438-7.116h12.639c4.17 0 7.734 3.005 8.438 7.116z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.599 115.548h-59.692v-11.965c0-5.116 4.147-9.263 9.263-9.263h41.166c5.116 0 9.263 4.147 9.263 9.263z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m426.306 249.833h-23.741c-10.659 0-19.845-7.503-21.974-17.947l-12.279-60.238c-7.914-38.825-42.063-66.714-81.686-66.714h-140.242c-29.548 0-54.426 22.101-57.908 51.443l-8.699 73.313c-1.363 11.489-11.104 20.143-22.674 20.143-20.542 0-37.81 15.426-40.116 35.838l-9.753 86.301c-1.163 10.291 6.888 19.303 17.245 19.303h461.037c11.151 0 19.408-10.365 16.915-21.234l-16.713-72.88c-6.351-27.694-30.997-47.328-59.412-47.328z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.312 171.649c-7.914-38.825-42.063-66.714-81.686-66.714h-140.242c-29.548 0-54.426 22.101-57.908 51.443l-8.699 73.313c-1.363 11.489-11.104 20.143-22.674 20.143h345.462c-10.659 0-19.845-7.503-21.974-17.947z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m343.002 183.603c-6.468-31.729-34.375-54.521-66.756-54.521h-133.45c-13.402 0-24.685 10.024-26.264 23.332 0 0-10.057 95.767-10.784 97.42h248.395c-.474-1.117-11.141-66.231-11.141-66.231z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.718 297.163c-6.351-27.696-30.997-47.33-59.412-47.33h-23.74c-10.659 0-19.845-7.503-21.974-17.947l-12.279-60.238c-7.914-38.825-42.063-66.714-81.686-66.714h-59.873v286.342h258.763c11.151 0 19.408-10.365 16.915-21.234z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m210.217 391.276h-168.831c1.099-48.997 38.466-88.334 84.421-88.334 45.943 0 83.311 39.337 84.41 88.334z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m473.288 391.276h-168.841c1.099-48.997 38.477-88.334 84.421-88.334 45.943 0 83.321 39.337 84.42 88.334z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m467.887 317.207v74.069h20.71c11.151 0 19.408-10.365 16.915-21.234l-13.102-57.132c-.536-2.339-2.618-3.997-5.017-3.997h-11.213c-4.58.001-8.293 3.714-8.293 8.294z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m81.608 397.248h-72.828c-4.849 0-8.78-3.931-8.78-8.78v-24.21c0-4.849 3.931-8.78 8.78-8.78h72.828c4.849 0 8.78 3.931 8.78 8.78v24.21c0 4.849-3.931 8.78-8.78 8.78z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.22 397.248h-72.828c-4.849 0-8.78-3.931-8.78-8.78v-24.21c0-4.849 3.931-8.78 8.78-8.78h72.828c4.849 0 8.78 3.931 8.78 8.78v24.21c0 4.849-3.931 8.78-8.78 8.78z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m184.677 393.36c0 8.987-2.018 17.495-5.615 25.114-5.827 12.331-15.816 22.32-28.161 28.133-7.604 3.612-16.126 5.615-25.099 5.615-32.521 0-58.876-26.355-58.876-58.862 0-32.521 26.355-58.876 58.876-58.876s58.875 26.355 58.875 58.876z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.801,
    cy: 393.355,
    fill: "url(#SVGID_13_)",
    r: 29.986
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.062 418.474c-5.827 12.331-15.816 22.32-28.161 28.133l-38.079-38.079c-4.275-3.668-6.998-9.1-6.998-15.167 0-11.033 8.945-19.978 19.978-19.978 6.081 0 11.513 2.723 15.181 7.012z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.801,
    cy: 393.355,
    fill: "url(#SVGID_15_)",
    rx: 19.979,
    ry: 19.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.739 375.486c1.348 2.689 2.107 5.723 2.107 8.936 0 11.032-8.945 19.975-19.98 19.975-3.213 0-6.248-.759-8.937-2.107 3.28 6.546 10.051 11.04 17.872 11.04 11.034 0 19.979-8.943 19.979-19.976.001-7.819-4.494-14.588-11.041-17.868z",
    fill: "url(#SVGID_16_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m447.744 393.36c0 8.987-2.018 17.495-5.615 25.114-5.827 12.331-15.816 22.32-28.161 28.133-7.604 3.612-16.126 5.615-25.099 5.615-32.521 0-58.876-26.355-58.876-58.862 0-32.521 26.355-58.876 58.876-58.876s58.875 26.355 58.875 58.876z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.868,
    cy: 393.355,
    fill: "url(#SVGID_18_)",
    r: 29.986
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.128 418.474c-5.827 12.331-15.816 22.32-28.161 28.133l-38.079-38.079c-4.275-3.668-6.998-9.1-6.998-15.167 0-11.033 8.945-19.978 19.978-19.978 6.081 0 11.513 2.723 15.181 7.012z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.868,
    cy: 393.355,
    fill: "url(#SVGID_20_)",
    rx: 19.979,
    ry: 19.976
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.805 375.486c1.348 2.689 2.107 5.723 2.107 8.936 0 11.032-8.945 19.975-19.98 19.975-3.213 0-6.248-.759-8.937-2.107 3.28 6.546 10.051 11.04 17.872 11.04 11.034 0 19.979-8.943 19.979-19.976.001-7.819-4.494-14.588-11.041-17.868z",
    fill: "url(#SVGID_21_)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m311.366 397.248h-108.623c-5.808 0-10.516-4.708-10.516-10.516v-20.739c0-5.808 4.708-10.516 10.516-10.516h108.623c5.808 0 10.516 4.708 10.516 10.516v20.739c0 5.808-4.708 10.516-10.516 10.516z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m215.626 146.729c0-3.839-3.112-6.951-6.951-6.951h-56.048c-11.89 0-21.9 8.248-23.301 19.198 0 0-5.704 50.375-8.32 71.266-.592 4.726 3.094 8.894 7.857 8.894h79.812c3.839 0 6.951-3.112 6.951-6.951z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.33 229.799c-2.858-15.58-8.082-45.159-8.082-45.159-5.738-26.108-30.497-44.862-59.225-44.862h-26.876c-3.839 0-6.951 3.112-6.951 6.951v85.458c0 3.839 3.112 6.951 6.951 6.951h86.394c4.944-.001 8.681-4.476 7.789-9.339z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m198.01 299.996h-27.423c-2.733 0-4.948-2.215-4.948-4.948v-27.422c0-2.733 2.215-4.948 4.948-4.948h27.423c2.733 0 4.948 2.216 4.948 4.948v27.422c0 2.733-2.215 4.948-4.948 4.948z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.441 335.428h-27.422c-2.733 0-4.948-2.215-4.948-4.948v-27.423c0-2.733 2.215-4.948 4.948-4.948h27.422c2.733 0 4.948 2.216 4.948 4.948v27.423c.001 2.733-2.215 4.948-4.948 4.948z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.225 299.996h-27.423c-2.733 0-4.948-2.215-4.948-4.948v-27.422c0-2.733 2.216-4.948 4.948-4.948h27.423c2.733 0 4.948 2.216 4.948 4.948v27.422c0 2.733-2.215 4.948-4.948 4.948z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.657 335.428h-27.423c-2.733 0-4.948-2.215-4.948-4.948v-27.423c0-2.733 2.216-4.948 4.948-4.948h27.423c2.733 0 4.948 2.216 4.948 4.948v27.423c0 2.733-2.216 4.948-4.948 4.948z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.44 299.996h-27.422c-2.733 0-4.948-2.215-4.948-4.948v-27.422c0-2.733 2.215-4.948 4.948-4.948h27.422c2.733 0 4.948 2.216 4.948 4.948v27.422c0 2.733-2.215 4.948-4.948 4.948z",
    fill: "url(#SVGID_29_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.18 345.548h21.589c2.496 0 4.519-2.023 4.519-4.519v-24.516c0-2.496-2.023-4.519-4.519-4.519h-18.818c-2.299 0-4.232 1.727-4.49 4.011l-2.771 24.517c-.303 2.68 1.794 5.026 4.49 5.026z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.104 291.452c-8.229-24.643-31.379-41.619-57.798-41.619h-23.74c-10.659 0-19.845-7.503-21.974-17.947v36.367c0 12.813 10.387 23.199 23.199 23.199z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.578 389.781-131.772-131.772c-1.89-.616-3.266-2.383-3.266-4.478v-34.892c0-2.609 2.116-4.735 4.735-4.735 6.317 0 12.028 2.64 16.054 6.892l2.26 11.093c2.136 10.446 11.319 17.944 21.981 17.944h23.737c28.411 0 53.062 19.639 59.41 47.331l9.234 40.243 7.478 32.632c1.93 8.392-2.569 16.496-9.851 19.742z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.274 258.268c-2.617 0-4.739-2.122-4.739-4.739v-34.886c0-2.617 2.122-4.739 4.739-4.739 12.251 0 22.182 9.931 22.182 22.182 0 12.251-9.931 22.182-22.182 22.182z",
    fill: "url(#SVGID_33_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaxi);
export default __webpack_public_path__ + "static/media/icon-taxi.1efca796aaff6335f16d3b5015903f80.svg";
export { ForwardRef as ReactComponent };